import type { FocusEvent, MouseEvent } from 'react';

/**
 * Native `<input type="datetime-local">` (และ `type="date"` / `type="time"`)
 * บน Chromium บน Windows เปิด picker ได้เฉพาะตอนคลิก icon ปฏิทินเล็กๆ ที่
 * ขอบขวาของ input — คลิกตรงกลาง input ไม่มีอะไรเกิดขึ้น. Admin งงว่า
 * จะกรอกยังไง.
 *
 * `showPicker()` (Chromium 99+ / Firefox 101+) บังคับเปิด picker จากคลิก/
 * focus ที่ไหนใน input ก็ได้. Safari + iOS + Firefox เก่ายังไม่รองรับ —
 * try/catch ครอบให้ fallback กลับเป็น native behavior เดิม (คลิก icon ขวา).
 *
 * Usage — spread เข้า input ที่เป็น datetime/date/time:
 *
 *   <input
 *     type="datetime-local"
 *     value={...}
 *     onChange={...}
 *     {...datetimePickerHandlers}
 *   />
 *
 * ห้าม spread เข้า input type อื่น — `showPicker()` บน text input จะ throw
 * `NotSupportedError` (try/catch จับได้ แต่เป็นการเสีย CPU เปล่า).
 */
function tryShow(el: HTMLInputElement): void {
  try {
    el.showPicker?.();
  } catch {
    /* unsupported — native fallback */
  }
}

export const datetimePickerHandlers = {
  onClick: (e: MouseEvent<HTMLInputElement>) => tryShow(e.currentTarget),
  onFocus: (e: FocusEvent<HTMLInputElement>) => tryShow(e.currentTarget),
} as const;
